import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { GridBackground } from "./components/GridBackground";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Projects } from "./components/Projects";
import { Process } from "./components/Process";
import { WhyUs } from "./components/WhyUs";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingWhatsapp } from "./components/FloatingWhatsapp";
import { initLenis } from "./lib/smoothScroll";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App relative min-h-screen bg-obsidian text-white font-sans antialiased">
      <GridBackground />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <Projects />
          <Process />
          <WhyUs />
          <Contact />
        </main>
        <Footer />
      </div>
      <FloatingWhatsapp />
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
}

export default App;
